import { render, staticRenderFns } from "./ccRecords.vue?vue&type=template&id=6d782a6b&scoped=true&"
import script from "./ccRecords.vue?vue&type=script&lang=js&"
export * from "./ccRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d782a6b",
  null
  
)

export default component.exports